import "../styles/legal.css"
import { useNavigate } from "react-router-dom"

export default function RefundPage() {
    const nav = useNavigate()
    return (
        <div className="legal-page">
            <nav className="legal-nav">
                <span className="legal-logo" onClick={() => nav("/")}>ArbSignal</span>
            </nav>

            <div className="legal-content">
                <h1>Refund Policy</h1>
                <p className="legal-updated">Last updated: April 2026</p>

                <h2>30-day money-back guarantee</h2>
                <p>
                    We offer a full refund within <strong>30 days of your initial subscription payment</strong>.
                    No questions asked. If ArbSignal isn't right for you, we'll refund your money.
                </p>

                <h2>How to request a refund</h2>
                <p>Email <a href="mailto:support@arb-signal.com">support@arb-signal.com</a> with:</p>
                <ul>
                    <li>The email address used for your subscription</li>
                    <li>The transaction ID (from your payment confirmation email)</li>
                    <li>A brief reason (optional, helps us improve)</li>
                </ul>
                <p>Refunds are typically processed within <strong>2 business days</strong> and appear on your
                    card within 5–10 business days depending on your bank.</p>

                <h2>What's covered</h2>
                <ul>
                    <li>First-time subscriptions: full refund within 30 days</li>
                    <li>Annual plans: prorated refund within the first 30 days, then no refund for the year</li>
                    <li>Monthly plans: refund of the most recent payment only</li>
                </ul>

                <h2>What's NOT covered</h2>
                <ul>
                    <li>Subscriptions older than 30 days (monthly auto-renewal)</li>
                    <li>Annual subscriptions after the 30-day window</li>
                    <li>Refunds requested after canceling (cancel directly stops future billing)</li>
                </ul>

                <h2>Cancellation vs Refund</h2>
                <p>You can <strong>cancel anytime</strong> from your dashboard — this stops future billing
                    but does not refund past payments. Use cancellation if you simply want to stop the service.
                    Use the refund process if you want your money back for the most recent payment.</p>

                <h2>Disputes</h2>
                <p>If you have a dispute that we can't resolve via email, payments are processed by
                    Dodo Payments who acts as our Merchant of Record. You can also contact them directly
                    through your transaction confirmation email.</p>

                <h2>Contact</h2>
                <p>Questions about this policy? Email <a href="mailto:support@arb-signal.com">support@arb-signal.com</a></p>
            </div>
        </div>
    )
}
